import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { IntraoccularPressureLeftEyeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface IntraoccularPressureLeftEyeActionFormGroup {
	iop: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-intraoccular-pressure-left-eye-action-controls',
    templateUrl: './intraoccular-pressure-left-eye-action-controls.component.html',
    styleUrls: ['../../../common.scss', './intraoccular-pressure-left-eye-action-controls.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntraoccularPressureLeftEyeActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: IntraoccularPressureLeftEyeAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as IntraoccularPressureLeftEyeAction;
	}

	@Input() form!: FormGroup<IntraoccularPressureLeftEyeActionFormGroup>;
	@Input() item!: Row | null;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('iop', this.formBuilder.control(this.action?.iop ?? null));
	}
}